import { CustomElement } from "../../core/CustomElement";

import ko from "knockout";
import CCCDialog from "../dialog/dialog";

export default class BugDbDialogVM {
  $customElement: CustomElement;
  bugDbUrl: string | null;
  // Observables.
  error: KnockoutObservable<string>;
  saved: KnockoutObservable<boolean>;
  bugId: KnockoutObservable<string>;
  // Computed
  bugDbLink: KnockoutComputed<string>;
  ready: KnockoutComputed<boolean>;

  constructor($customElement: CustomElement) {
    this.$customElement = $customElement;
    this.bugDbUrl = null;
    this.error = ko.observable();
    this.saved = ko.observable(false);
    this.bugId = ko.observable("");
    this.bugDbLink = ko.computed(() => {
      return this.bugDbUrl + this.bugId();
    });
    this.ready = ko.computed(() => {
      // if (this.selectedJiraProject()) {
      //   return true;
      // } else {
      //   return false;
      // }
      return true;
    });
  }

  closeDialog: () => void = () => {
    (
      this.$customElement.shadowDom.querySelector(
        ".ccc-bug-db-dialog"
      ) as CCCDialog
    ).close();
  };

  openBug: () => void = () => {
    window.open(this.bugDbLink(), "_blank");
  };
}
